export default __webpack_public_path__ + "static/pdp--callout-2-6d988adef0339c6edf19cdc47b77a59c.jpg";